import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import { 
    API_GET_DOCUMENT_STATS, 
    API_GET_DOCUMENT_MONTHLY_STATS, 
    API_GET_FILLED_DOCUMENT_STATS,
    API_GET_FILLED_DOCUMENT_MONTHLY_STATS,
    API_GET_TEMPLATE_DOCUMENT_STATS,
    API_GET_TEMPLATE_DOCUMENT_MONTHLY_STATS,
    API_GET_PAYMENT_STATS, 
    API_GET_PAYMENT_MONTHLY_STATS,
    API_GET_USER_STATS,
    API_GET_USER_MONTHLY_STATS
} from './StatsConstants';

export interface StatItem {
    date: string;
    paid: number;
    unpaid: number;
    total?: number;
}

export interface StatsResponse {
    isSuccess: boolean;
    response: StatItem[];
    messageForUser: string;
}

export class StatsService {
    private httpService = new HttpService();
    private logger = new Logger();

    async getDocumentStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_DOCUMENT_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getDocumentMonthlyStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_DOCUMENT_MONTHLY_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getFilledDocumentStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_FILLED_DOCUMENT_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getFilledDocumentMonthlyStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_FILLED_DOCUMENT_MONTHLY_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getTemplateDocumentStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_TEMPLATE_DOCUMENT_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getTemplateDocumentMonthlyStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_TEMPLATE_DOCUMENT_MONTHLY_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getPaymentStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_PAYMENT_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getPaymentMonthlyStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_PAYMENT_MONTHLY_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getUserStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_USER_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getUserMonthlyStats(): Promise<StatsResponse> {
        try {
            const httpResult = await this.httpService.get(API_GET_USER_MONTHLY_STATS, {});
            return {
                isSuccess: httpResult.data.isSuccess,
                response: httpResult.data.response,
                messageForUser: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
